import { Box, Theme, useTheme, colors } from "@mui/material";
import React from "react";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { calcDynamicSeatMapStaticImage } from "../InteractiveSeatMap/utils.seatMap";
import { useSelectActiveEvent } from "../PurchaseSeats/ChooseSeats/useSelectActiveEvent";

interface Props {
  onClick?: (n: any) => void;
  onLoad?: (viewer: any) => void;
  venueId: string;
  mapId: string;
}

export function Map2dViewer(props: Props) {
  const teamConfig = useTeamConfig();
  const seatMapConfigs = teamConfig?.seatMapConfigs;
  const { activeEvent } = useSelectActiveEvent();
  const theme = useTheme();
  const containerRef = React.useRef(null);
  const DVM = window.DVM;

  const sectionNameFontSize = seatMapConfigs?.customSectionNameFontSize || 14;
  const staticSeatMapImage = calcDynamicSeatMapStaticImage(teamConfig, activeEvent);

  const start = (viewer: any) => {
    // ---- LOADING MAP ----
    var load_options: any = {
      venue_id: props.venueId,
      map_id: props.mapId,
    };

    // Load the map
    viewer
      .loadMap(load_options)
      .then(function (obj: any) {
        props?.onLoad?.(viewer);
        // applying custom styles
        let currentStyles = viewer.getStyles();
        viewer.setStyles(
          createMapStyles({ theme, currentStyles, sectionNameFontSize })
        );
      })
      .catch(function (err: any) {
        console.error(err);
      });
  };

  React.useEffect(() => {
    if (containerRef.current) {
      const input_options = {
        container: containerRef.current,
        callbacks: {
          click: props?.onClick,
        },
      };

      DVM?.loadModule("map_viewer", input_options)
        .then(function (viewer) {
          start(viewer);
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  }, []);

  if (staticSeatMapImage) {
    return (
      <Box
        component={"img"}
        src={staticSeatMapImage}
        alt="Seat Map"
        width={"100%"}
        {...seatMapConfigs?.customSeatMapStaticImageStyle}
      />
    );
  }

  return <Box ref={containerRef} width={"100%"} height={"100%"} />;
}

const createMapStyles = ({
  theme,
  currentStyles,
  sectionNameFontSize,
}: {
  theme: Theme;
  currentStyles: any;
  sectionNameFontSize: number;
}) => {
  const textFontSize = sectionNameFontSize;
  const selected = {
    fillStyle: theme.palette.primary.main,
    strokeStyle: theme.palette.warning.main,
    lineWidth: 2,
    text: true,
    textFillStyle: theme.palette.common.white,
    textFontSize,
  };

  return currentStyles.map((itm: any, idx: any) => {
    if (idx == 0) {
      let modified = {
        ...itm,
        section: {
          ...itm.section,
          available: {
            ...itm.section.available,
            normal: {
              ...itm.section.available.normal,
              selected,
              none: {
                ...itm.section.available.normal.none,
                textFontSize,
                textFillStyle: colors.grey[700],
              },
            },
            hover: {
              ...itm.section.available.hover,
              selected,
              none: {
                ...itm.section.available.hover.none,
                textFontSize,
                textFillStyle: theme.palette.common.white,
              },
            },
          },

          // unavailable: {
          //   ...itm.section.unavailable,
          //   normal: {
          //     ...itm.section.unavailable.normal,
          //     none: {
          //       ...itm.section.unavailable.normal.none,
          //       textFontSize: 24,
          //     },
          //   },
          // },
        },
      };
      return modified;
    }
    return itm;
  });
};
